
// Met a jour la pastille du panier de l'en-tete du theme V2 (exclut l'assurance colis)
window.legacySyncCartBubble = function () {
  try {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { window.legacyUpdateCartBubble(c); })
      .catch(function () {});
  } catch (e) {}
};
window.legacyUpdateCartBubble = function (state) {
  try {
    if (!state || !state.items) return;
    var INSURANCE_PID = 9859504472401;
    var n = 0;
    state.items.forEach(function (it) {
      var pid = it.product_id || (it.product && it.product.id);
      if (pid !== INSURANCE_PID) n += it.quantity;
    });
    // Le theme V2 rend DEUX icones panier (une bureau masquee, une mobile) :
    // il faut mettre a jour les deux, pas seulement la premiere du document.
    var cibles = document.querySelectorAll('[data-ref="cart-count"], .header__icon-count-bubble-inner');
    for (var i = 0; i < cibles.length; i++) {
      cibles[i].textContent = n;
      var bulle = cibles[i].closest ? cibles[i].closest('.header__icon-count-bubble') : null;
      if (bulle) bulle.classList.toggle('header__icon-count-bubble--long', n >= 100);
    }
  } catch (e) {}
};

// Recalcule l'etat "panier vide" apres une modification en AJAX.
//
// Pourquoi c'est necessaire : la reponse de /cart/change renvoie item_count = 1
// quand on retire le dernier produit, parce que la ligne d'assurance colis est
// encore la — l'application ne la retire qu'ensuite, par un second appel qui ne
// touche pas la classe is-empty. Le panier restait donc affiche comme non vide :
// pas de bouton "Continuer les achats", et le bandeau promo + le minuteur
// restaient visibles alors qu'il n'y avait plus rien.
//
// On compte donc les articles HORS assurance, exactement comme le fait le Liquid
// du bloc promo, et on relance le calcul un peu plus tard pour attraper la
// suppression asynchrone de l'assurance.
window.LEGACY_INSURANCE_PID = 9859504472401;

window.legacyApplyCartState = function (state) {
  try {
    if (!state || !state.items) return;
    var PID = window.LEGACY_INSURANCE_PID;
    var comp = window.legacyComparePrices || {};
    var qte = 0;
    var promo = false;
    state.items.forEach(function (it) {
      var pid = it.product_id || (it.product && it.product.id);
      if (pid === PID) return;
      qte += it.quantity;
      var ref = comp[it.variant_id];
      if (ref && ref > it.price) promo = true;
    });
    var vide = qte === 0;

    var articles = document.querySelector('cart-items');
    var pied = document.getElementById('main-cart-footer');
    if (articles) articles.classList.toggle('is-empty', vide);
    if (pied) pied.classList.toggle('is-empty', vide);

    // Bandeau promotion et minuteur de reservation : meme regle que le Liquid
    // qui les rend au chargement de la page.
    var coupon = document.querySelector('.offer-coupon');
    var minuteur = document.querySelector('.cart-timer');
    if (coupon) coupon.style.display = (!vide && promo) ? 'block' : 'none';
    if (minuteur) minuteur.style.display = vide ? 'none' : 'block';

    // Les libelles de paliers Kaching sont re-injectes par le re-rendu de section.
    if (typeof window.legacyTranslateBundleLabels === 'function') window.legacyTranslateBundleLabels();
  } catch (e) {}
};

window.legacyRefreshCartState = function (state) {
  if (state) window.legacyApplyCartState(state);
  try {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { window.legacyApplyCartState(c); })
      .catch(function () {});
  } catch (e) {}
};

// Support du panier de l'ancien thème MINOPIA : helpers + <quantity-input>
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Extrait de global.js de l'ancien thème MINOPIA — uniquement l'element <quantity-input>
if (!customElements.get('quantity-input')) {
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);
}
